import { getFullName } from "@repo/utils";

import { useSettings } from "../settings/SettingsProvider";

interface NameProps {
  firstName?: string;
  lastName: string;
  abbreviate?: boolean;
}

// This component is used to display a person's full name based on their first and last names
// It supports localization for name order and masking
// It DOES NOT handle abbreviation
export const Name = ({ firstName, lastName }: NameProps) => {
  const { general, customerMode } = useSettings();

  if (!firstName && !lastName) {
    return null;
  }

  return (
    <>
      {getFullName(
        firstName,
        lastName,
        general?.localization?.reverse_names,
        customerMode
      )}
    </>
  );
};
